import Axios           from 'axios';
import { getFormData } from '$/lib/utils';

import { Entity }                        from '$/entities/BaseEntity';
import { BaseRole }                      from '$/entities/roles/BaseRole';
import type { File, FileUploadProgress } from '$/entities/File';

import { Building as BuildingCommon } from '$/common/entities/Building';
export *                              from '$/common/entities/Building';

@Entity()
export class Building extends BuildingCommon {

	async uploadBuildingDocs(docs: File[], progressUpdate?: FileUploadProgress) {
		const formData = getFormData(...docs);
		if (_.isEmpty(Array.from(formData.values()))) {
			return;
		}

		await Axios.post(Building.collectionUrl(`${this.id}/documents`), formData, { onUploadProgress : progressEvent => {
			progressUpdate?.(progressEvent.loaded / progressEvent.total);
		} });
	}

	static getSample<B extends typeof Building>(this: B): InstanceType<B> {
		const sample    = super.getSample() as InstanceType<B>;
		sample.country  = BaseRole.current.org.country || sample.country;
		sample.province = BaseRole.current.org.province || sample.province;
		sample.city     = 'Sample City';
		return sample;
	}

}
